import { Box, Typography } from "@mui/material";
import React from "react";

interface SummaryProps {
  summaryLabel: string;
  summaryValue: string;
}

export const GraphSummary: React.FC<SummaryProps> = (props) => {
  return (
    <Box
      display={"flex"}
      marginY={"40px"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignContent={"center"}
      alignItems={"center"}
    >
      <Box
        width={"35%"}
        display={"flex"}
        alignContent={"center"}
        flexDirection={"row"}
        justifyContent={"space-between"}
      >
        <Typography fontSize="20px">{props.summaryLabel}</Typography>
        <Typography fontSize="20px" fontWeight={"600"}>
          {props.summaryValue}
        </Typography>
      </Box>

      <Box
        width={"55%"}
        height={"16px"}
        bgcolor={"#39d29f"}
        borderRadius={"200px"}
      />
    </Box>
  );
};